import { styled } from '../jss-style';
import avatarStyle from './avatar';

const useAvatarStyle = styled(avatarStyle, 'avatar');
export { avatarStyle, useAvatarStyle };
export default useAvatarStyle;
